import { render, staticRenderFns } from "./wxActRule.vue?vue&type=template&id=68f2438d"
import script from "./wxActRule.vue?vue&type=script&lang=js"
export * from "./wxActRule.vue?vue&type=script&lang=js"
import style0 from "./wxActRule.vue?vue&type=style&index=0&id=68f2438d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports